import React from "react"
import { Grid } from "@mui/material"

import {UserSettingsSitesTable, UserSettingSitesDrawer} from "./Sites"
import {UserSettingsProvidersTable, UserSettingProvidersDrawer} from "./Providers"


export default function UserSettingsWebsitesTab() {
    return <Grid container spacing={1}>
		<Grid item xs={6}>
			<UserSettingsSitesTable />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsProvidersTable />
		</Grid>

		<UserSettingSitesDrawer />
		<UserSettingProvidersDrawer />
    </Grid>
}